import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import appLogo from '../../assets/images/header-logo.png';
import menuOpenImg from '../../assets/images/menu-open.svg';
import menuCloseImg from '../../assets/images/menu-cross.svg';
import Viber from '../../assets/images/viber.svg';
import Insta from '../../assets/images/Insta.svg';
import Whatsapp from '../../assets/images/whatsapp.svg';
import FaceBook from '../../assets/images/Facebook.svg';
import VK from '../../assets/images/vk.svg';
import Max from '../../assets/images/max.svg';
import ModalMenu from "../ModalMenu/ModalMenu";
import AnchorLink from "react-anchor-link-smooth-scroll";
import './Header.styles.scss';
import { Logo } from '../../shared/logo/Logo';
import { Burger } from '../../shared/burger/Burger';
import { useDevice } from '../../hooks/use-device/useDevice';

const Header = () => {
    const location = useLocation();
    const [isMenuActive, setMenuActive] = useState(false);
    const { isDesktop } = useDevice();

    useEffect(() => {
        if (isMenuActive) {
            document.documentElement.style.overflow = 'hidden'; // Disable scrolling
        } else {
            document.documentElement.style.overflow = 'auto'; // Enable scrolling
        }

        // Clean up function to reset the overflow style
        return () => {
            document.documentElement.style.overflow = 'auto';
        };
    }, [isMenuActive]);

    const handleBurgerClick = () => {
        setMenuActive(!isMenuActive);
    };

    return (
        <>
            <header className={`header ${isMenuActive ? 'back-color' : ''}`}>
                <div className='container'>
                    <div className='header-wrapper'>
                        <Logo variant="default" />
                        {!isDesktop &&
                            <Burger isActive={isMenuActive} onClick={handleBurgerClick} />
                        }
                        <div className='header-menu-wrapper'>
                            {window.location.pathname === '/thank-you' ? (
                                <ul className='header-menu-list'>
                                    <li className='header-menu-item'><a href="/" className='anchor-link'>Для частных лиц</a></li>
                                    <li className='header-menu-item'><a href="/for-companies" className='anchor-link'>Для компаний</a></li>
                                    <li className='header-menu-item'><a href="https://alpairya.ru" target='__blank' className='anchor-link orange'>Разработка ПО и Приложений</a></li>
                                </ul>
                            ) : (
                                <ul className='header-menu-list'>
                                    <li className='header-menu-item'><a href="/for-companies" className='anchor-link'>Для компаний</a></li>
                                    <li className='header-menu-item'><AnchorLink href="#kontakt" className='anchor-link'>Контакты</AnchorLink></li>
                                    <li className='header-menu-item'><a href="https://alpairya.ru" target='__blank' className='anchor-link orange'>Разработка ПО и Приложений</a></li>
                                </ul>
                            )}

                        </div>
                        <ul className='social-list'>
                            <li className="social-list__item">
                                <a href='https://vk.com/belo_klining' target='__blank' className="social-list__link">
                                    <img src={VK} alt="ВКонтакте" />
                                </a>
                            </li>
                            <li className="social-list__item">
                                <a href='https://max.ru/belo_klining' target='__blank' className="social-list__link">
                                    <img src={Max} alt="МАКС" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
            {isMenuActive && <ModalMenu closeMenu={() => setMenuActive(false)} />}
        </>
    );
};
export default Header;